import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Radio, Tooltip } from 'antd';
import { SubmissionScope } from '../../types';
import { SubmissionScopes } from '../../misc';
import { ExclamationCircleIcon } from '../../../custom_shared/icons';
import { useAppStore } from '../../stores';
import './SubmissionScopeSelect.less';

interface Props {
    submissionScope: SubmissionScope | null;
    setSubmissionScope: (submissionScope: SubmissionScope) => void;
    mainSectionLabel: string;
    tooltipText: string;
    style?: React.CSSProperties;
}

const SubmissionScopeSelect: React.FC<Props> = ({
    submissionScope,
    setSubmissionScope,
    mainSectionLabel,
    tooltipText,
    style
}) => {
    const { actionStore, controlStateStore } = useAppStore();

    if (!submissionScope) {
        return null;
    }

    return (
        <div className="submission-scope-select-container" style={style}>
            <Radio.Group
                className="submission-scope-radio-group"
                value={submissionScope}
                disabled={controlStateStore.inputsDisabled}
                onChange={event => {
                    setSubmissionScope(event.target.value);
                    actionStore.rebuildNodes();
                }}
            >
                <Radio value={SubmissionScopes.MainSectionOnly}>{mainSectionLabel}</Radio>
                <Radio value={SubmissionScopes.SectionLevel}>Per individual section</Radio>
            </Radio.Group>

            <Tooltip
                title={
                    <>
                        <div>{tooltipText}</div>
                        <div>For existing contracts, this setting may be locked to its original level.</div>
                    </>
                }
                placement="topLeft"
                overlayStyle={{
                    maxWidth: 800
                }}
            >
                <ExclamationCircleIcon width={20} height={20} color="#717887" />
            </Tooltip>
        </div>
    );
};

export default observer(SubmissionScopeSelect);
